import { Highlight, Stack } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { kycAuth } from "../Redux/Action/kyc/kycAuthAction";
import { getDomainConfig } from "../Utils/dynamicBranding";

export const KYCAuth = () => {
  useEffect(() => {
    // Set page title dynamically based on domain
    const config = getDomainConfig();
    document.title = `KYC Authentication - ${config.title}`;
  }, []);

  const dispatch = useDispatch();
  const [message, setMessage] = useState("Processing your request...");
  const [closeBrowser, setCloseBrowser] = useState(false);
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    if (closeBrowser) {
      const interval = setInterval(() => {
        setCountdown((prev) => {
          if (prev === 1) {
            clearInterval(interval);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);

      const timer = setTimeout(() => {
        window.open("", "_self");
        window.close();
      }, 5000);

      return () => {
        clearTimeout(timer);
        clearInterval(interval);
      };
    }
  }, [closeBrowser]);

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);

    const email = queryParams.get("email");
    const type = queryParams.get("type");
    const uid = queryParams.get("uid");

    if (email && type && uid) {
      const payload = { email, type, uid };
      dispatch(
        kycAuth({
          payload,
          callback: (data) => {
            if (data?.meta?.code === 200) {
              setMessage(data?.meta?.message || "KYC Auth successful");
              setCloseBrowser(true);
            } else {
              setMessage("KYC Auth failed. Please try again later.");
            }
          },
        })
      );
    }
  }, []);

  return (
    <Stack
      gap="5"
      align="center"
      maxW="md"
      margin="auto"
      borderRadius="10px"
      padding="3rem"
      paddingTop="5rem"
    >
      {message}
    </Stack>
  );
};